import React from 'react';
import './SummaryStats.css';

function SummaryStats() {
    const stats = [
        { value: "40%", label: "Faster Processing", sub: "mobile origination" },
        { value: "30%", label: "Better Recovery", sub: "intelligent tracking" },
        { value: "100%", label: "Audit-Ready", sub: "compliance trails" },
        { value: "360°", label: "Customer View", sub: "integrated KYC" }
    ];

    return (
        
        <section className="summary-stats-premium">
            <section className="unified-finance-section">

  <div className="unified-container">

    {/* LEFT CONTENT */}
    <div className="unified-content">

      <h2 className="unified-title">
        Unified Financial Operations in 
        <span> One Intelligent Dashboard</span>
      </h2>

      <p className="unified-description">
        IGNOSI provides a comprehensive cloud banking solution that brings 
        gold loans, personal/business loans, and investment management 
        into a single, role-based dashboard. Gain complete control over 
        your financial operations with real-time insights and AI-powered intelligence.
      </p>

      <h4 className="capability-heading">Key Capabilities</h4>

      <div className="capability-list">

        <div className="capability-item">
          <span>📊</span>
          <p><strong>Smart Dashboard</strong> – Role-based views for management, branches, recovery teams, and auditors</p>
        </div>

        <div className="capability-item">
          <span>💰</span>
          <p><strong>Loan Lifecycle Management</strong> – Digital origination to NPA recovery with customizable schemes</p>
        </div>

        <div className="capability-item">
          <span>📈</span>
          <p><strong>Investment Management</strong> – Complete SB/FD/RD/Debenture handling with automated payouts</p>
        </div>

        <div className="capability-item">
          <span>🛡️</span>
          <p><strong>Compliance & Security</strong> – Audit-ready processes with regulatory compliance indicators</p>
        </div>

        <div className="capability-item">
          <span>🤖</span>
          <p><strong>AI Intelligence</strong> – Face Detection, Behavior analysis, fraud detection, and predictive risk alerts</p>
        </div>

      </div>

    </div>

  </div>

</section>
            <div className="stats-container-premium">
                <div className="stats-header-premium">
                    <h2 className="stats-title-premium">Transforming Banking Operations</h2>
                    <p className="stats-subtitle-premium">Efficiency delivered through intelligent automation and secure engineering.</p>
                </div>
                <div className="stats-grid-premium">
                    {stats.map((item, idx) => (
                        <div key={idx} className="stat-card-premium">
                            <div className="stat-value-premium">{item.value}</div>
                            <div className="stat-label-premium">{item.label}</div>
                            <div className="stat-sub-premium">{item.sub}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default SummaryStats;
